/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebSecuredConfiguration } from '../shiva-web-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createOcppConfiguration } from '../fn/ocpp-connection/create-ocpp-configuration';
import { CreateOcppConfiguration$Params } from '../fn/ocpp-connection/create-ocpp-configuration';
import { exportConnectionTagsOcppDefinition } from '../fn/ocpp-connection/export-connection-tags-ocpp-definition';
import { ExportConnectionTagsOcppDefinition$Params } from '../fn/ocpp-connection/export-connection-tags-ocpp-definition';
import { getOcppConfigurations } from '../fn/ocpp-connection/get-ocpp-configurations';
import { GetOcppConfigurations$Params } from '../fn/ocpp-connection/get-ocpp-configurations';
import { importConnectionTagsOcppDefinition } from '../fn/ocpp-connection/import-connection-tags-ocpp-definition';
import { ImportConnectionTagsOcppDefinition$Params } from '../fn/ocpp-connection/import-connection-tags-ocpp-definition';
import { importStationOcppConfiguration } from '../fn/ocpp-connection/import-station-ocpp-configuration';
import { ImportStationOcppConfiguration$Params } from '../fn/ocpp-connection/import-station-ocpp-configuration';
import { listOcppConfigurations } from '../fn/ocpp-connection/list-ocpp-configurations';
import { ListOcppConfigurations$Params } from '../fn/ocpp-connection/list-ocpp-configurations';
import { OcppConfig } from '../models/ocpp-config';
import { OcppConfigList } from '../models/ocpp-config-list';
import { removeOcppConfiguration } from '../fn/ocpp-connection/remove-ocpp-configuration';
import { RemoveOcppConfiguration$Params } from '../fn/ocpp-connection/remove-ocpp-configuration';
import { setOcppConfiguration } from '../fn/ocpp-connection/set-ocpp-configuration';
import { SetOcppConfiguration$Params } from '../fn/ocpp-connection/set-ocpp-configuration';


/**
 * All about the ocpp connections
 */
@Injectable({ providedIn: 'root' })
export class OcppConnectionService extends BaseService {
  constructor(config: ShivaWebSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listOcppConfigurations()` */
  static readonly ListOcppConfigurationsPath = '/stations/{uid}/ocpp';

  /**
   * List a station ocpp configurations.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listOcppConfigurations()` instead.
   *
   * This method doesn't expect any request body.
   */
  listOcppConfigurations$Response(params: ListOcppConfigurations$Params, context?: HttpContext): Observable<StrictHttpResponse<OcppConfigList>> {
    return listOcppConfigurations(this.http, this.rootUrl, params, context);
  }

  /**
   * List a station ocpp configurations.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listOcppConfigurations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listOcppConfigurations(params: ListOcppConfigurations$Params, context?: HttpContext): Observable<OcppConfigList> {
    return this.listOcppConfigurations$Response(params, context).pipe(
      map((r: StrictHttpResponse<OcppConfigList>): OcppConfigList => r.body)
    );
  }

  /** Path part for operation `createOcppConfiguration()` */
  static readonly CreateOcppConfigurationPath = '/stations/{uid}/ocpp';

  /**
   * Create a station Ocpp configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOcppConfiguration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOcppConfiguration$Response(params: CreateOcppConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createOcppConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a station Ocpp configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createOcppConfiguration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOcppConfiguration(params: CreateOcppConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.createOcppConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `importStationOcppConfiguration()` */
  static readonly ImportStationOcppConfigurationPath = '/stations/{uid}/ocpp/import';

  /**
   * Import the ocpp configurations for a station.
   *
   * Allows to import the ocpp configurations, via a csv File.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importStationOcppConfiguration()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  importStationOcppConfiguration$Response(params: ImportStationOcppConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return importStationOcppConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Import the ocpp configurations for a station.
   *
   * Allows to import the ocpp configurations, via a csv File.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importStationOcppConfiguration$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  importStationOcppConfiguration(params: ImportStationOcppConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.importStationOcppConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getOcppConfigurations()` */
  static readonly GetOcppConfigurationsPath = '/stations/{uid}/ocpp/{ocppUid}';

  /**
   * Get a station Ocpp configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOcppConfigurations()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOcppConfigurations$Response(params: GetOcppConfigurations$Params, context?: HttpContext): Observable<StrictHttpResponse<OcppConfig>> {
    return getOcppConfigurations(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a station Ocpp configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOcppConfigurations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOcppConfigurations(params: GetOcppConfigurations$Params, context?: HttpContext): Observable<OcppConfig> {
    return this.getOcppConfigurations$Response(params, context).pipe(
      map((r: StrictHttpResponse<OcppConfig>): OcppConfig => r.body)
    );
  }

  /** Path part for operation `exportConnectionTagsOcppDefinition()` */
  static readonly ExportConnectionTagsOcppDefinitionPath = '/stations/{uid}/ocpp/configuration/{ocppUid}/export';

  /**
   * Export the OCPP tags definitions in csv format for a station.
   *
   * Allows to export the tags definitions, via a XLS File.
   * The connectionUid must be a valid OcppUid.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportConnectionTagsOcppDefinition()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportConnectionTagsOcppDefinition$Response(params: ExportConnectionTagsOcppDefinition$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportConnectionTagsOcppDefinition(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the OCPP tags definitions in csv format for a station.
   *
   * Allows to export the tags definitions, via a XLS File.
   * The connectionUid must be a valid OcppUid.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportConnectionTagsOcppDefinition$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportConnectionTagsOcppDefinition(params: ExportConnectionTagsOcppDefinition$Params, context?: HttpContext): Observable<Blob> {
    return this.exportConnectionTagsOcppDefinition$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `setOcppConfiguration()` */
  static readonly SetOcppConfigurationPath = '/stations/{uid}/ocpp/configuration/{ocppUid}/import';

  /**
   * update a station Ocpp configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setOcppConfiguration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  setOcppConfiguration$Response(params: SetOcppConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return setOcppConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * update a station Ocpp configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `setOcppConfiguration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  setOcppConfiguration(params: SetOcppConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.setOcppConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `importConnectionTagsOcppDefinition()` */
  static readonly ImportConnectionTagsOcppDefinitionPath = '/stations/{uid}/ocpp/configuration/{ocppUid}/import';

  /**
   * Import the OCPP tags definitions for a station.
   *
   * Allows to import the tags definitions, via a XLS File.
   * The connectionUid must be a valid OcppUid.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importConnectionTagsOcppDefinition()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importConnectionTagsOcppDefinition$Response(params: ImportConnectionTagsOcppDefinition$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return importConnectionTagsOcppDefinition(this.http, this.rootUrl, params, context);
  }

  /**
   * Import the OCPP tags definitions for a station.
   *
   * Allows to import the tags definitions, via a XLS File.
   * The connectionUid must be a valid OcppUid.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importConnectionTagsOcppDefinition$Response()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importConnectionTagsOcppDefinition(params: ImportConnectionTagsOcppDefinition$Params, context?: HttpContext): Observable<void> {
    return this.importConnectionTagsOcppDefinition$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `removeOcppConfiguration()` */
  static readonly RemoveOcppConfigurationPath = '/stations/{uid}/ocpp/configuration/{ocppUid}/import';

  /**
   * Remove the station Ocpp configuration.
   *
   * Remove Ocpp configuration
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeOcppConfiguration()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeOcppConfiguration$Response(params: RemoveOcppConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return removeOcppConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Remove the station Ocpp configuration.
   *
   * Remove Ocpp configuration
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeOcppConfiguration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeOcppConfiguration(params: RemoveOcppConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.removeOcppConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
